// ✅ AddNatureActe.jsx (corrigé)

import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import axiosInstance from "../../../variables/api/axiosInstance";

const AddNatureActe = ({ show, handleClose, editMode, selectedNatureActe, natureActes, onAdd, onUpdate }) => {
  const [loading, setLoading] = useState(false);
  const [libelle, setLibelle] = useState("");
  const [type, setType] = useState("");

  useEffect(() => {
    if (editMode && selectedNatureActe) {
      setLibelle(selectedNatureActe.libelleParametre || "");
      setType(selectedNatureActe.type || "");
    } else {
      setLibelle("");
      setType("");
    }
  }, [editMode, selectedNatureActe]);

  const onSubmit = (e) => {
    e.preventDefault();
    if (!libelle.trim()) {
      toast.warning("Le libellé ne peut pas être vide.");
      return;
    }

    if (!type.trim()) {
      toast.warning("Le type ne peut pas être vide.");
      return;
    }

    const isDuplicate = !editMode && natureActes?.some(
      (item) => item.libelleParametre.toLowerCase() === libelle.trim().toLowerCase()
    );
    if (isDuplicate) {
      toast.error("Cette nature d'acte existe déjà.");
      return;
    }

    setLoading(true);

    const natureActeData = {
      parametreId: selectedNatureActe?.parametreId,
      libelleParametre: libelle.trim(),
      typeParametre: "NATURE_ACTE",
      type: type
    };

    const request = editMode
      ? axiosInstance.put(`/api/parametre`, natureActeData)
      : axiosInstance.post(`/api/parametre`, natureActeData);

    request
      .then((res) => {
        toast.success(
          editMode ? "Nature de l'acte modifiée avec succès" : "Nature de l'acte ajoutée avec succès"
        );
        setLibelle("");
        if (editMode && onUpdate) onUpdate(res.data);
        if (!editMode && onAdd) onAdd(res.data);
        handleClose();
      })
      .catch((err) => {
        console.error("Erreur:", err);
        toast.error("Erreur lors de l'opération.");
      })
      .finally(() => setLoading(false));
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Body>
        <button
          type="button"
          className="btn-close btn-primary"
          onClick={handleClose}
          aria-label="Close"
        ></button>
        <div className="text-center mb-6">
          <h4 className="address-title mb-2">
            {editMode ? "Modifier la" : "Ajouter une"} nature de l'acte
          </h4>
          <p className="address-subtitle">
            {editMode ? "Modifier la" : "Ajouter une nouvelle"} nature de l'acte
          </p>
        </div>
        <form id="addNewNatureActeForm" className="row g-12" onSubmit={onSubmit}>
          <div className="col-12 col-md-12">
            <label className="form-label" htmlFor="modalNatureActeLibelle">
              Libellé
            </label>
            <input
              type="text"
              id="modalNatureActeLibelle"
              onChange={(e) => setLibelle(e.target.value)}
              className="form-control"
              placeholder="Libellé de la nature de l'acte"
              name="libelle"
              value={libelle}
              required
            />
          </div>
          <div className="col-12 col-md-12">
            <label className="form-label" htmlFor="type">
              Type d'acte
            </label>
            <select
              id="type"
              onChange={(e) => setType(e.target.value)}
              className="form-control"
              placeholder="Type de la nature de l'acte"
              name="type"
              value={type}
              required
            >
              <option value="">Sélectionner le type d'acte</option>
              <option value="MEDICAL">MEDICAL</option>
              <option value="MECANIQUE">MECANIQUE</option>
            </select>
          </div>
          <div className="col-12 text-center">
            <button
              type="submit"
              className="btn btn-primary me-3"
              disabled={loading}
            >
              {loading && <span className="spinner-grow me-1" role="status" aria-hidden="true"></span>}
              {loading ? `Enregistrement...` : `Enregistrer`}
            </button>
            <button
              type="button"
              className="btn btn-label-secondary"
              onClick={handleClose}
            >
              Annuler
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default AddNatureActe;
